import React from 'react';
import { BarChart as RechartsBarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';

interface BarChartProps {
  data: any[];
  xKey: string;
  yKeys: string[];
  colors?: string[];
  height?: number;
  showGrid?: boolean;
  showLegend?: boolean;
  stacked?: boolean;
}

const defaultColors = ['#3b82f6', '#8b5cf6', '#10b981', '#f59e0b', '#ef4444'];

export function BarChart({ 
  data, 
  xKey, 
  yKeys, 
  colors = defaultColors, 
  height = 300,
  showGrid = true,
  showLegend = true,
  stacked = false
}: BarChartProps) {
  return (
    <ResponsiveContainer width="100%" height={height}>
      <RechartsBarChart data={data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
        {showGrid && (
          <CartesianGrid 
            strokeDasharray="3 3" 
            className="stroke-gray-200 dark:stroke-gray-700" 
          />
        )}
        <XAxis 
          dataKey={xKey} 
          tick={{ fontSize: 12 }}
          className="fill-gray-600 dark:fill-gray-300"
          axisLine={{ strokeWidth: 1 }}
          stroke="currentColor"
        />
        <YAxis 
          tick={{ fontSize: 12 }}
          className="fill-gray-600 dark:fill-gray-300"
          axisLine={{ strokeWidth: 1 }}
          stroke="currentColor"
        />
        <Tooltip 
          contentStyle={{
            backgroundColor: 'var(--tooltip-bg)',
            border: '1px solid var(--tooltip-border)',
            borderRadius: '8px',
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
            color: 'var(--tooltip-text)'
          }}
          wrapperClassName="[--tooltip-bg:white] dark:[--tooltip-bg:#1f2937] [--tooltip-border:#e5e7eb] dark:[--tooltip-border:#374151] [--tooltip-text:#111827] dark:[--tooltip-text:#f9fafb]"
        />
        {showLegend && <Legend wrapperStyle={{ color: 'var(--legend-text)' }} className="[--legend-text:#6b7280] dark:[--legend-text:#9ca3af]" />}
        {yKeys.map((key, index) => (
          <Bar
            key={key}
            dataKey={key}
            fill={colors[index % colors.length]}
            stackId={stacked ? 'stack' : undefined}
            radius={[2, 2, 0, 0]}
          />
        ))}
      </RechartsBarChart>
    </ResponsiveContainer>
  );
}